export default __webpack_public_path__ + "static/media/Md Abu Sufian resume.2eca8fda.pdf";